import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.console);
  return menu;
};

const configSections: ConfigSection[] = [{ component: "RomesteadBasicSection", props: { name: "basic" } }];

// The game writes binary protocol data to stdout which gets captured by the PTY.
// Only keep lines that are printable ASCII text (the server has no Unicode output).
const PRINTABLE_LINE = /^[\x20-\x7e\t]*$/;
const consoleFilter = (message: string): string | null => {
  if (!message || !PRINTABLE_LINE.test(message)) return null;
  return message;
};

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  consoleFilter,
  statusPageConfig: {
    ...defaultProfile().statusPageConfig,
    showQueryPort: false,
    showRconPort: false,
  },
});
